import { Form, Input } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { SiteGroupEntity } from "src/app/features/SiteGroup/types/SiteGroupEntity";
import { SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { siteGroupsSelectConfig, statusSelectorConfig } from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";
import { getAssignedDataGroup } from "../../../../../core/router/auth";

export const SitesSearchForm: FC<SearchFormProps<SiteGroupEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("orgUnitsSearchForm.criteriaBadges.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
            <Form.Item label={t("orgUnitsSearchForm.criteriaBadges.siteId")} name="siteId">
                <TextInput name="siteId" />
            </Form.Item>
            <Form.Item label={t("orgUnitsSearchForm.criteriaBadges.partnerId")} name="partnerId">
                <TextInput name="partnerId" />
            </Form.Item>
            <Form.Item label={t("orgUnitsSearchForm.criteriaBadges.parentSiteId")} name="parentUnit">
                <SelectDynamic
                    name="parentUnit"
                    label={t("orgUnitsSearchForm.criteriaBadges.parentSiteId")}
                    fieldConfig={siteGroupsSelectConfig}
                />
            </Form.Item>
            <Form.Item label={t("orgUnitsSearchForm.criteriaBadges.contractNumber")} name="contractNumber">
                <TextInput name="contractNumber" />
            </Form.Item>
            <Form.Item label={t("form.status")} name="status">
                <SelectDynamic name="status" label={t("form.status")} fieldConfig={statusSelectorConfig} />
            </Form.Item>
            <Form.Item label={t("form.system.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>

            <Form.Item name="dataGroupId" hidden initialValue={getAssignedDataGroup()?.id}>
                <Input type="hidden" />
            </Form.Item>
        </SearchForm>
    );
};
